export default __webpack_public_path__ + "static/media/Consulting-rafiki.5f54112e.svg";